export var isAddVoucherSuccessResponse = function (response) {
    return Boolean(response.shoppingBag);
};
export var isAddVoucherErrorResponse = function (response) {
    return typeof response.isSuccess === "boolean" &&
        !response.isSuccess;
};
